import React from 'react';
import useProfile from '../hooks/useProfile';

interface IProps {
  handleModalOpen: (data: any) => void;
}

const UserProfileSettings = ({ handleModalOpen }: IProps) => {
  const { name, email, role, initials } = useProfile();

  return (
    <div className="main-content">
      <div className="settings-page">
        <div className="settings-card">
          <div className="settings-card-head">
            <b>Profile</b>
            <span>How you appear to other users in the app</span>
          </div>
          <div className="settings-card-body">
            <div className="settings-profile">
              <span className="settings-avatar" aria-hidden="true">
                {initials}
              </span>
              <div>
                <div className="settings-name">{name}</div>
                <div className="settings-email">
                  {[email, role].filter(Boolean).join(' · ')}
                </div>
              </div>
            </div>
            <div className="settings-grid">
              <div className="input-group">
                <label htmlFor="settings-name">Name</label>
                <input id="settings-name" type="text" readOnly value={name} />
              </div>
              <div className="input-group">
                <label htmlFor="settings-role">Role</label>
                <input id="settings-role" type="text" readOnly value={role} />
              </div>
              <div className="input-group span-2">
                <label htmlFor="settings-email">Email</label>
                <input id="settings-email" type="text" readOnly value={email} />
                <span className="settings-hint">
                  Your email is your sign-in and can&apos;t be changed here.
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="settings-card">
          <div className="settings-card-head">
            <b>Security</b>
          </div>
          <div className="settings-card-body">
            <div className="settings-row">
              <div>
                <div className="settings-row-title">Password</div>
                <div className="settings-row-sub">
                  Choose a strong password you don&apos;t use elsewhere.
                </div>
              </div>
              <button
                type="button"
                className="btn-app btn-app--outline btn-app--sm"
                onClick={() => handleModalOpen({ modal: 'settings' })}
              >
                Change password
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfileSettings;
